function LockedInput({ text, style }: { text: string; style?: any }) {
  return (
    <div className="locked-input" style={{ ...style }}>
      {text}
    </div>
  );
}
export default LockedInput;
